import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getUserName',
})
export class GetUserNamePipe implements PipeTransform {
  transform(obj: any): any {
    let res = '';
    if (obj && obj.fullName) {
      res += obj.fullName;
    }
    return res;
  }
}
